import {
    Document,
    Page,
    StyleSheet,
    Text,
    View,
} from "@react-pdf/renderer";
import HeaderReport from "../../../../components/Pdf/Header";
import { fDate, fMoney } from "../../../../libs/tools/format";
import FooterReport from "../../../../components/Pdf/Footer";


const s = StyleSheet.create({
    body: {
        paddingVertical: "30px",
        paddingHorizontal: "20px",
    },

    title: {
        fontSize: "12px",
        textAlign: "center",
        fontFamily: "Helvetica-Bold",
    },

    header: {
        backgroundColor: "#730A29",
        textAlign: "center",
        color: "#FFFFFF",
        fontWeight: "bold"
    },

    mCell: { padding: "1px" },
    mxCell: { paddingHorizontal: "2px" },

    vCenter: { alignItems: "center", justifyContent: "center" },
    vCenterL: { alignItems: "left", justifyContent: "center" },
    vCenterR: { alignItems: "end", justifyContent: "center" },
    vCenterBtw: { alignItems: "stretch", justifyContent: "center" },

    dflexBtw: { display: "flex", justifyContent: "space-between" },
    dflexEnd: { display: "flex", justifyContent: "flex-end" },

    alignE: { alignContent: "flex-end" },

    row: { flexDirection: "row" },
    flexWrap: { display: "flex", flexWrap: "wrap", flexDirection: "row" },

    w5: { width: "5%" },
    w10: { width: "10%" },
    w15: { width: "15%" },
    w20: { width: "20%" },
    w21: { width: "21.1%" },
    w25: { width: "25%" },
    w30: { width: "30%" },
    w33: { width: "33%" },
    w34: { width: "34%" },
    w36: { width: "36%" },
    w29: { width: "28.9%" },
    w40: { width: "40%" },
    w45: { width: "45%" },
    w50: { width: "50%" },
    w55: { width: "55%" },
    w60: { width: "60%" },
    w65: { width: "65%" },
    w70: { width: "70%" },
    w75: { width: "75%" },
    w80: { width: "80%" },
    w90: { width: "90%" },
    w100: { width: "100%" },
    wAuto: { width: "auto" },

    fborder: { border: "1px solid #000" },
    border: { border: "1px solid #000", borderBottom: "0px" },
    borderT: { borderBottom: "1px solid #000" },
    borderB: { borderBottom: "1px solid #000" },
    borderB2: { borderBottom: "2px solid #000" },
    borderE: { borderRight: "1px solid #000" },
    borderS: { borderLeft: "1px solid #000" },
    borderBS: { borderBottom: "4px solid #730A29" },
    borderHE: { borderRight: "1px solid #FFFFFF" },
    borderD: { border: "1px solid #000", borderTop: "0px" },

    bg: { backgroundColor: "#BEBEBE" },
    bg2: { backgroundColor: "#BEBEBE" },
    bglg: { backgroundColor: "#adb5bd" },

    fs7: { fontSize: "7px" },
    fs8: { fontSize: "8px" },
    fs9: { fontSize: "9px" },
    fs10: { fontSize: "10px" },
    fs11: { fontSize: "11px" },
    fs12: { fontSize: "12px" },
    fs13: { fontSize: "13px" },

    tend: { textAlign: "right", paddingRight: "2px" },
    tstart: { textAlign: "left" },
    tcenter: { textAlign: "center" },
    tBold: { fontFamily: "Helvetica-Bold" },

    mT1: { marginTop: "1px" },
    mT2: { marginTop: "2px" },
    mT8: { marginTop: "8px" },
    mT30: { marginTop: "30px" },
    mT20: { marginTop: "20px" },
    mT70: { marginTop: "70px" },
    mx5: { marginHorizontal: "5px" },
    mx18: { marginHorizontal: "18px" },
    mx20: { marginHorizontal: "20px" },
    mb2: { marginBottom: "2px" },

    spaceFooter: {
        bottom: 10,
        left: 0,
        right: 0,
        width: "auto",
        height: 30,
        marginHorizontal: 10,
    },
});

export default async function MinimoVital(data, cfg, t, fileNo) {
    return {
        report: (
            <Document>
                <Page style={[s.body, s.fs10]}>
                    <HeaderReport />
                    <View style={[s.title]}>
                        <Text>EMPLEADOS CON EL MÍNIMO VITAL</Text>
                    </View>
                    <View style={[s.mT8]}>
                        <View style={[s.row, s.header, s.tcenter, s.fborder]}>
                            <View style={[s.w10, s.borderHE]}>
                                <Text style={[s.mCell]}>No.</Text>
                            </View>
                            <View style={[s.w15, s.borderHE]}>
                                <Text style={[s.mCell]}>No. Empleado</Text>
                            </View>
                            <View style={[s.w75]}>
                                <Text style={[s.mCell]}>Detalle</Text>
                            </View>
                        </View>
                        {
                            data.map((el, ix)=>(
                                <Persona key={ix} ix={ix} el={el}/>
                            ))
                        }
                    </View>
                    <FooterReport fileNo={fileNo}/>
                </Page>
            </Document>
        ),
    };
}

function Persona({ ix, el }) {
    return (
        <View style={[s.row, s.borderD]}>
            <View style={[s.w10, s.borderE, s.vCenter]}>
                <Text>{ix + 1}</Text>
            </View>
            <View style={[s.w15, s.borderE, s.vCenter]}>
                <Text>{el.staffNumber}</Text>
            </View>
            <View style={[s.w75, s.mCell, s.mxCell]}>
                <View style={[s.row, s.mb2]}>
                    <View style={[s.w40]}>
                        <Text style={[s.tBold]}>NOMBRE</Text>
                        <Text>{el.fullName}</Text>
                    </View>
                    <View style={[s.w60]}>
                        <Text style={[s.tBold]}>PUESTO</Text>
                        <Text>{el.nameJob}</Text>
                    </View>
                </View>
                <View style={[s.mb2]}>
                    <View style={[]}>
                        <Text style={[s.tBold]}>ÁREA</Text>
                        <Text>{el.name}</Text>
                    </View>
                </View>
                <View style={[s.row, s.mb2]}>
                    <View style={[s.w50]}>
                        <Text style={[s.tBold]}>FECHA INICIO</Text>
                        <Text>{fDate(el.created)}</Text>
                    </View>
                    <View style={[s.w50]}>
                        <Text style={[s.tBold]}>FECHA TÉRMINO</Text>
                        <Text>{fDate(el.modified)}</Text>
                    </View>
                </View>
                <View style={[s.row, s.mb2]}>
                    <View style={[s.w20]}>
                        <Text style={[s.tBold]}>PORCENTAJE</Text>
                        <Text>{el.minVital}</Text>
                    </View>
                    <View style={[s.w30]}>
                        <Text style={[s.tBold]}>SUELDO TABULADOR</Text>
                        <Text>{fMoney(el.net)}</Text>
                    </View>
                    <View style={[s.w50]}>
                        <Text style={[s.tBold]}>SUELDO TABULADOR C/PORCENTAJE</Text>
                        <Text>{fMoney(el.suPor)}</Text>
                    </View>
                </View>
            </View>
        </View>
    )
}
